import React from 'react';
import FormHelp from '@/components/forms/FormHelp';

interface FormHelpTooltipProps {
    children: React.ReactNode;
}

const FormHelpTooltip = React.memo((
    {
        children,
    }: FormHelpTooltipProps,
) => (
    <FormHelp content={children} icon='mdi-information-outline' className='text-info' />
));

export default FormHelpTooltip;
